// extracted by mini-css-extract-plugin
module.exports = {"TextLoading":"TextLoading_TextLoading__2mbf8","text":"TextLoading_text___U7Ez"};